<section class="hero">
  <!-- Video background -->
  <div class="hero-media">
    <video class="hero-video" autoplay muted loop playsinline>
      <source src="https://karimexclusives.b-cdn.net/acacia/Acacia%20landing%20page%20animation.webm" type="video/webm" />
      <source src="https://karimexclusives.b-cdn.net/acacia/Acacia%20landing%20page%20animation.mp4"  type="video/mp4"  />
    </video>
    <div class="hero-overlay"></div>
    <div class="hero-vignette"></div>
    <div class="hero-grain"></div>
  </div>

  <div class="hero-content">

    <p class="hero-signature">Enter The Wilderness</p>

    <div class="hero-actions">
      <button class="btn-primary hero-brochure-btn" (click)="openBrochure()">Download Brochure</button>
      <button class="btn-outline hero-enquire-btn" (click)="openEnquire()">Enquire Now</button>
    </div>
  </div>

  <div class="hero-scroll" aria-hidden="true">
    <div class="scroll-line"></div>
  </div>
</section>
